import { FC } from 'react'
import { ListRow } from 'src/tailwind-components/extends/List'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

import s from '../../styles.module.less'

type TProps = {
  isMobile: boolean
}

const TableColumnSkeleton: FC<TProps> = ({ isMobile }) =>
  isMobile ? (
    <ListRow className={s.item}>
      <div className={s.skeletonTitle}>
        <PlaceholderCell height={20} />
      </div>
      <div className={s.skeletonSubTitle}>
        <PlaceholderCell height={48} />
      </div>
    </ListRow>
  ) : (
    <ListRow className={s.item}>
      <div className={s.contactName}>
        <PlaceholderCell height={20} />
      </div>
      <div className={s.phone}>
        <PlaceholderCell height={20} />
      </div>
      <div>
        <PlaceholderCell height={20} />
      </div>
    </ListRow>
  )

export default TableColumnSkeleton
